import React, { useEffect } from 'react';
import styles from './Style.module.css';
import { useGetSelectedOutlet } from '../../APICalling/useApiQueries';
import { calculateEndTime, formatDate } from '../../Utils/Helper';
import { useLocation } from 'react-router-dom';
import isEqual from 'lodash.isequal';
import { OutletCard } from '../../Components/OutletCard/OutletCard';
import LoaderOutletCard from '../../Components/OutletCard/LoaderOutletCard';
import TimeDetail from '../TimeDetail/TimeDetail';
import ServiceDetails from '../ServiceDetails/ServiceDetails';
import PriceDetails from '../PriceDetails/PriceDetails';
import { useAppointment } from '../../Context/Appointment/AppointmentContext';
import { useLocation as useLocationContext } from '../../Context/Location/LocationContext';
import { useSchedule } from '../../Context/Schedule/ScheduleContext';
import { useGuests } from '../../Context/Guests/GuestsContext';
import { useBookingSession } from '../../Context/BookingSession/BookingSessionContext';
import { useWebSettings } from '../../Context/WebSettings/WebSettingsContext';
import { useCartDisplayTotal } from '../../Utils/Hooks/useCartDisplayTotal';
import { resolveBookingDateTime } from '../../Utils/resolveBookingDateTime';

export const AppointmentSummary = ({
  noTitle = false,
  noServicePrice = false,
  noAddonsPrice = false,
  noPriceDetails = false,
  noBookingID = false,
  isDepositPaid = false,
}) => {
  const { deposit } = useWebSettings();
  const { appointmentTypeID, membership } = useAppointment();
  const { selectedOutletID } = useLocationContext();
  const { selectedDate, selectedTime } = useSchedule();
  const appointmentTime = resolveBookingDateTime(selectedDate, selectedTime).time;
  const { members, updateMembers } = useGuests();
  const { bookingID } = useBookingSession();

  const isMemberFlowSummary = Number(appointmentTypeID) === 1 || Number(appointmentTypeID) === 2;

  const { data: outletResponse, isLoading } = useGetSelectedOutlet(selectedOutletID, { is_image: 1 });
  const outletData = outletResponse?.data?.data || [];
  const cartDisplayTotal = useCartDisplayTotal(members, membership);
  // Start/end time on each member's services (single + group)
  useEffect(() => {
    if (!isMemberFlowSummary) return;
    const updatedServicesGroup = (members || []).map((member) => {
      const svcList = member?.services || [];
      return {
        ...member,
        services: svcList.map((service, index) => {
          let localStartTime = appointmentTime || '00:00:00';
          const totalDurationUpToIndex = svcList
            .slice(0, index)
            .reduce((acc, subItem) => acc + parseInt(subItem?.duration || 0), 0);
          if (index > 0) {
            localStartTime = appointmentTime ? calculateEndTime(appointmentTime, totalDurationUpToIndex) : '';
          }
          const localEndTime = calculateEndTime(localStartTime, parseInt(service?.duration || 0));
          return {
            ...service,
            startTime: localStartTime,
            endTime: localEndTime,
          };
        }),
      };
    });

    if (!isEqual(updatedServicesGroup, members)) {
      updateMembers(() => updatedServicesGroup);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentTime, appointmentTypeID, isMemberFlowSummary]);

  return (
    <>
    <div className={`${styles.AppointmentSummary}`}>
      {noTitle ? "" : <h2 className="section-title space-b">Review and Confirm</h2>}
       <div className={`${styles.outletCardContainer} space-b`}>
        {isLoading
        ?
        <LoaderOutletCard skeletonCount={1} hideSelectBtn={true} />
        :
        <OutletCard 
          image={outletData?.image}
          name={outletData?.name}
          address={outletData?.address}
          hideContact={true}
          hideSelectBtn={true}
          hideAnnouncements={true}
          hideTiming={true}
        /> 
        }
        </div>

        <div className="space-b">
        <TimeDetail
        selectedDate={selectedDate}
        selectedTime={selectedTime}
          bookingID={noBookingID ? null : bookingID}
        />
        </div>


        {isMemberFlowSummary ? (
          <ServiceDetails
          members={members}
          noServicePrice={noServicePrice}
          noAddonsPrice={noAddonsPrice}
          />
        ) : null}

        {!noPriceDetails &&
        <PriceDetails
        cartTotal={cartDisplayTotal}
        depositMoney={deposit}
        isDepositPaid={isDepositPaid}
        />
        }

    </div>
    </>
  )
}
